let html = `
<svg><use xlink:href="#sprite-hd"></use></svg>
`

export default html